import React from "react"
import PropTypes from "prop-types"

import Product from "@irati/products/types/Product"
import tracking from "@irati-tracking/platform"
import ProductTrackingNames from "@irati/products/enums/ProductTrackingNames"

import Products from "@irati/products/enums/Products"
import {StyledLink, StyledRouterLink} from "./styled"

interface Props {
  cardId: string,
  children: JSX.Element,
  href?: string,
  product: Product,
  to?: string,
  trackingName: ProductTrackingNames
}

interface Context {
  apps: {[key: string]: string}
}

const TenantProductLink = (props: Props, {apps}: Context) => {
  const {cardId, children, href, product, trackingName, to} = props

  const app = product.product === Products.rewards ? apps.FLEXIREWARDS : apps[product.product]

  if (to) {
    return (
      <StyledRouterLink
        id={cardId}
        to={to}
        app={app}
        onClick={() => tracking.click("homepage_card", {product: trackingName, active: true, source: "homepage"})}
        plain>
        {children}
      </StyledRouterLink>
    )
  }

  if (href) {
    return (
      <StyledLink
        id={cardId}
        href={href}
        target="_blank"
        onClick={() => tracking.click("homepage_card", {product: trackingName, active: false})}
        plain>
        {children}
      </StyledLink>
    )
  }

  return children
}

TenantProductLink.contextTypes = {
  apps: PropTypes.object
}

export default TenantProductLink
